export default {
  en: {
    enumeration_name: "{0} Enumeration",
    Request: "Request",
    Parameter: "Parameter",
    Description: "Description",
    Parameter_Type: "Parameter Type",
    Required: "Required",
    request_parameter_header: "Request header, path, and query parameters",
    Optional: "Optional",
    request_body_header: "Allowed request content types",
    Content_Type_Header: "Content-Type Header",
    Content_Type: "Content Type",
    Content_Description: "Content Description",
    Content_Required: "Content Required",
    Responses: "Responses",
    request_header: "Allowed response codes and content types",
  },
  es : {
    enumeration_name: "Enumeración {0}",
    Request: "Petición",
    Parameter: "Parámetro",
    Description: "Descripción",
    Parameter_Type: "Tipo de Parámetro",
    Required: "Obligatorio",
    request_parameter_header: "Parámetros en la cabecera, path y query de la petición",
    Optional: "Opcional",
    request_body_header: "Content types permitidos en la petición",
    Content_Type_Header: "Cabecera Content-Type",
    Content_Type: "Tipo de Contenido",
    Content_Description: "Descripción del Contenido",
    Content_Required: "Contenido Obligatorio",
    Responses: "Respuestas",
    request_header: "Códigos y Content types permitidos en la respuesta",
  },
  ca : {
    enumeration_name: "Enumeració {0}",
    Request: "Petició",
    Parameter: "Paràmetre",
    Description: "Descripció",
    Parameter_Type: "Tipus de Paràmetre",
    Required: "Obligatori",
    request_parameter_header: "Paràmetres dins la capcelera, path i query de la petició",
    Optional: "Opcional",
    request_body_header: "Content types permesos a la petició",
    Content_Type_Header: "Capcelera Content-Type",
    Content_Type: "Tipus de Contingut",
    Content_Description: "Descripció del Contingut",
    Content_Required: "Contingut Obligatori",
    Responses: "Respostes",
    request_header: "Codis i Content types permesos a la resposta",
  }
};
